import React, { useState, useEffect } from "react";
import "./Testimonials.css";

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

const testimonials = [
    {
      id: 1,
      name: "Rahul Sharma",
      role: "Regular Customer",
      rating: 5,
      comment: "The best taxi service in Mumbai! Always on time and the drivers are very professional. I use them for my daily commute to work.",
      avatar: "RS"
    },
    {
      id: 2,
      name: "Priya Patel",
      role: "Business Traveler",
      rating: 4,
      comment: "Great service for airport transfers. The app makes booking so easy and I love the real-time tracking feature.",
      avatar: "PP"
    },
    {
      id: 3,
      name: "Amit Desai",
      role: "Family User",
      rating: 5,
      comment: "We always use this service for family outings. The cars are clean and comfortable, and the drivers are very courteous.",
      avatar: "AD"
    },
    {
      id: 4,
      name: "Neha Gupta",
      role: "Corporate Client",
      rating: 5,
      comment: "Our company has been using their corporate service for years. Reliable, punctual, and excellent customer support.",
      avatar: "NG"
    },
    {
      id: 5,
      name: "Vikram Joshi",
      role: "Senior Citizen",
      rating: 5,
      comment: "As an elderly person, I appreciate the special care the drivers show me. They're always patient and helpful with my luggage.",
      avatar: "VJ"
    },
    {
      id: 6,
      name: "Sanjana Reddy",
      role: "Night Shift Worker",
      rating: 5,
      comment: "I feel completely safe using this service late at night after my shifts. The drivers are respectful and the cars are well-maintained.",
      avatar: "SR"
    },
    {
      id: 7,
      name: "Arjun Kapoor",
      role: "Tourist",
      rating: 4,
      comment: "Used this service during my Mumbai vacation. The drivers knew all the best routes and gave great local tips!",
      avatar: "AK"
    },
    {
      id: 8,
      name: "Meera Nair",
      role: "Student",
      rating: 5,
      comment: "The student discount makes this service very affordable. Never had any issues with cancellations or delays.",
      avatar: "MN"
    },
    {
      id: 9,
      name: "Rajiv Malhotra",
      role: "Frequent Traveler",
      rating: 5,
      comment: "I've tried many taxi services across India, but this one stands out for its consistency and professional drivers.",
      avatar: "RM"
    },
    {
      id: 10,
      name: "Ananya Singh",
      role: "First-time User",
      rating: 5,
      comment: "Impressed with my first ride! The car was spotless, the driver was courteous, and the fare was exactly as estimated.",
      avatar: "AS"
    },
        {
      id: 11,
      name: "Kavita Iyer",
      role: "Medical Professional",
      rating: 5,
      comment: "When rushing to the hospital for emergencies, their priority booking has been a lifesaver. Always reach on time!",
      avatar: "KI"
    },
    {
      id: 12,
      name: "Deepak Oberoi",
      role: "Event Planner",
      rating: 5,
      comment: "Perfect for wedding transportation! Managed 25 cars for our event seamlessly with their group booking feature.",
      avatar: "DO"
    },
    {
      id: 13,
      name: "Sunita Menon",
      role: "Working Mother",
      rating: 4,
      comment: "The child seat option gives me peace of mind when traveling with my toddler. Drivers are extra careful with kids.",
      avatar: "SM"
    },
    {
      id: 14,
      name: "Rohan Bhatia",
      role: "Tech Employee",
      rating: 5,
      comment: "Use their monthly corporate package. The dedicated account manager makes expense tracking effortless.",
      avatar: "RB"
    },
    {
      id: 15,
      name: "Nandini Rao",
      role: "Foreign Tourist",
      rating: 5,
      comment: "As a solo female traveler, I felt completely safe. Drivers spoke good English and knew all tourist spots.",
      avatar: "NR"
    },
    {
      id: 16,
      name: "Aditya Verma",
      role: "Luxury Traveler",
      rating: 5,
      comment: "Their premium fleet is truly world-class. Mercedes rides at half what regular limo services charge!",
      avatar: "AV"
    },
    {
      id: 17,
      name: "Pooja Mehta",
      role: "Senior Citizen",
      rating: 5,
      comment: "The 'ElderCare' drivers help with groceries and walk me to my doorstep. Beyond just transportation!",
      avatar: "PM"
    },
    {
      id: 18,
      name: "Vivek Choudhary",
      role: "Late Night Commuter",
      rating: 4,
      comment: "24/7 availability with real-time driver verification. Never feel unsafe returning from night shifts.",
      avatar: "VC"
    },
    {
      id: 19,
      name: "Anjali Kapoor",
      role: "Frequent Flyer",
      rating: 5,
      comment: "Flight delay? No problem! Their airport team tracks my flight and adjusts pickup automatically.",
      avatar: "AK"
    },
    {
      id: 20,
      name: "Rajat Singh",
      role: "Car Owner",
      rating: 5,
      comment: "Started using this instead of driving myself. Saves me 8 hours/week in Mumbai traffic!",
      avatar: "RS"
    },
    {
      id: 21,
      name: "Ishaan Patel",
      role: "College Student",
      rating: 5,
      comment: "50% student discount on night rides saved me during exams. Campus pickups are always prompt.",
      avatar: "IP"
    },
    {
      id: 22,
      name: "Trisha Nair",
      role: "Pet Owner",
      rating: 4,
      comment: "Only service that allows my Labrador without extra charges. Drivers carry water bowls too!",
      avatar: "TN"
    },
    {
      id: 23,
      name: "Arun Khanna",
      role: "Business Owner",
      rating: 5,
      comment: "Provide rides for my international clients. The professional drivers create great first impressions.",
      avatar: "AK"
    },
    {
      id: 24,
      name: "Mehak Grover",
      role: "Hospitality Manager",
      rating: 5,
      comment: "Partnered for our hotel's guest transfers. 100% on-time record for 3 years running!",
      avatar: "MG"
    },
    {
      id: 25,
      name: "Kabir Khan",
      role: "Film Crew",
      rating: 5,
      comment: "Only service that accommodates our equipment vans and odd-hour schedules for shoots.",
      avatar: "KK"
    },
        {
      id: 26,
      name: "Aarav Malhotra",
      role: "Wheelchair User",
      rating: 5,
      comment: "Their accessible vehicles with ramps are a game-changer. First service where drivers actually know how to secure wheelchairs properly.",
      avatar: "AM"
    },
    {
      id: 27,
      name: "Divya Kapoor",
      role: "Monsoon Commuter",
      rating: 5,
      comment: "During heavy rains when autos refuse, these taxis always come through with waterproof seat covers and safe drivers.",
      avatar: "DK"
    },
    {
      id: 28,
      name: "Rishi Agarwal",
      role: "Grocery Shopper",
      rating: 4,
      comment: "Love the trunk space in their XL vehicles - fits my monthly Big Bazaar haul with room to spare!",
      avatar: "RA"
    },
    {
      id: 29,
      name: "Myra Joshi",
      role: "Pregnant Commuter",
      rating: 5,
      comment: "Special 'Mom-to-Be' service with extra cushions and drivers who avoid potholes. Reduced my pregnancy stress significantly.",
      avatar: "MJ"
    },
    {
      id: 30,
      name: "Karan Sethi",
      role: "Intercity Traveler",
      rating: 5,
      comment: "Regularly book Mumbai-Pune rides. Fixed pricing even during peak hours unlike other aggregators.",
      avatar: "KS"
    },
    {
      id: 31,
      name: "Tanya Reddy",
      role: "Surprise Party Planner",
      rating: 5,
      comment: "Coordinated 15 surprise birthday pickups simultaneously through their group booking portal. Flawless execution!",
      avatar: "TR"
    },
    {
      id: 32,
      name: "Vihaan Nair",
      role: "EV Enthusiast",
      rating: 5,
      comment: "Their electric vehicle fleet is impressive! Super quiet rides and drivers explain the eco-benefits.",
      avatar: "VN"
    },
    {
      id: 33,
      name: "Ananya Deshpande",
      role: "Food Delivery Owner",
      rating: 5,
      comment: "Partnered for last-mile deliveries. Their temperature-controlled vehicles keep meals perfect.",
      avatar: "AD"
    },
    {
      id: 34,
      name: "Kabir Khanna",
      role: "Monument Tourist",
      rating: 5,
      comment: "Drivers double as guides! Know all about Gateway of India, Elephanta Caves etc. Better than paid tours.",
      avatar: "KK"
    },
    {
      id: 35,
      name: "Ira Mehta",
      role: "Train Station Commuter",
      rating: 5,
      comment: "Pre-book for early morning Lokmanya Tilak Terminus pickups. Never miss my 5:15am train anymore!",
      avatar: "IM"
    },
    {
      id: 36,
      name: "Reyansh Iyer",
      role: "Car Breakdown User",
      rating: 5,
      comment: "Used emergency roadside booking when my car failed. Arrived in 8 minutes at 2am!",
      avatar: "RI"
    },
    {
      id: 37,
      name: "Siya Kapoor",
      role: "Mall Shopper",
      rating: 4,
      comment: "Wait-time feature at Phoenix Mills is brilliant - driver comes exactly when I finish shopping.",
      avatar: "SK"
    },
    {
      id: 38,
      name: "Arjun Bajaj",
      role: "Festival Goer",
      rating: 5,
      comment: "Only service available during Ganesh Chaturthi immersions. Drivers know all the procession shortcuts.",
      avatar: "AB"
    },
    {
      id: 39,
      name: "Diya Chawla",
      role: "Hospital Visitor",
      rating: 5,
      comment: "Regular trips to Tata Memorial. Drivers know all hospital entrances and help with patient drop-offs.",
      avatar: "DC"
    },
    {
      id: 40,
      name: "Ayaan Gupta",
      role: "Local Explorer",
      rating: 5,
      comment: "Their 'Discover Mumbai' package took me to hidden gems even my Mumbaikar friends didn't know!",
      avatar: "AG"
    },
    {
      id: 41,
      name: "Kiara Malhotra",
      role: "Monsoon Wedding Guest",
      rating: 5,
      comment: "Saved my silk saree during rains! Arrived with umbrella service right at my building gate.",
      avatar: "KM"
    },
    {
      id: 42,
      name: "Vivaan Joshi",
      role: "Bike Owner",
      rating: 5,
      comment: "When my bike's in service, their bike-taxi alternative gets me through Mumbai's lanes fastest.",
      avatar: "VJ"
    },
    {
      id: 43,
      name: "Misha Reddy",
      role: "Art Collector",
      rating: 5,
      comment: "Only service I trust for transporting paintings. Climate-controlled and vibration-free rides.",
      avatar: "MR"
    },
    {
      id: 44,
      name: "Advait Nair",
      role: "Gym Goer",
      rating: 4,
      comment: "Early morning gym rides always on time. Drivers don't complain about my protein shake spills!",
      avatar: "AN"
    },
    {
      id: 45,
      name: "Zara Khan",
      role: "Fashion Designer",
      rating: 5,
      comment: "Transport my garment samples in pristine condition. Cars always smell fresh and clean.",
      avatar: "ZK"
    },
    {
      id: 46,
      name: "Virat Kapoor",
      role: "Local Guide",
      rating: 5,
      comment: "Recommend this to all my foreign tourists. Drivers speak multiple languages and accept forex cards.",
      avatar: "VK"
    },
    {
      id: 47,
      name: "Anika Sharma",
      role: "Monsoon Office Goer",
      rating: 5,
      comment: "Their 'Monsoon Guarantee' means no surge pricing when it rains - a lifesaver in Mumbai!",
      avatar: "AS"
    },
    {
      id: 48,
      name: "Dhruv Patel",
      role: "Tiffin Service Owner",
      rating: 5,
      comment: "Depend on them for daily lunch deliveries to offices. Never a single tiffin spill in 2 years!",
      avatar: "DP"
    },
    {
      id: 49,
      name: "Ishita Gupta",
      role: "Weekend Traveler",
      rating: 5,
      comment: "Alibaug weekend trips are effortless with their beach-ready vehicles and cooler provisions.",
      avatar: "IG"
    },
    {
      id: 50,
      name: "Rudra Sethi",
      role: "Car-Free Resident",
      rating: 5,
      comment: "Been using exclusively for 3 years instead of owning a car. Saved ₹3.2L annually on maintenance!",
      avatar: "RS"
    }
];

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % testimonials.length);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const goToPrev = () => {
    setActiveIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
    setIsAutoPlaying(false);
  };

  const goToNext = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const goToIndex = (index) => {
    setActiveIndex(index);
    setIsAutoPlaying(false);
  };

  return (
    <section className="testimonials-section">
      <div className="section-header-test">
        <h2 className="section-title">What Our Customers Say</h2>
        <p className="section-subtitle">
          Trusted by thousands of happy customers
        </p>
        <div className="animated-underline"></div>
      </div>

      <div className="testimonials-container">
        <button
          className="nav-button prev"
          onClick={goToPrev}
          aria-label="Previous testimonial"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
          </svg>
        </button>

        <div className="testimonials-track">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonial-card ${
                index === activeIndex ? "active" : ""
              }`}
              style={{
                transform: `translateX(${(index - activeIndex) * 100}%)`,
                opacity: index === activeIndex ? 1 : 0.5,
              }}
            >
              <p className="testimonial-text">"{testimonial.comment}"</p>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.role}</p>
                </div>
                <div className="rating-stars">
                  {[...Array(5)].map((_, i) => (
                    <span
                      key={i}
                      className={i < testimonial.rating ? "filled" : ""}
                    >
                      ★
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          className="nav-button next"
          onClick={goToNext}
          aria-label="Next testimonial"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
          </svg>
        </button>
      </div>

      {/* <div className="indicators">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === activeIndex ? 'active' : ''}`}
            onClick={() => goToIndex(index)}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div> */}
    </section>
  );
};

export default Testimonials;
